import { createAzureAuthenticator } from './AzureAuthenticator';
import { createAuthContext } from './AuthContext'
import { AzureAdClient } from '../config/config'
import { InteractionRequiredAuthError, OIDC_DEFAULT_SCOPES } from '@azure/msal-browser'
import EventBus from '../utils/EventBus'

// let Authenticator = undefined
// export const getAuthenticator = (specialScopes = []) => {
//   if ( !Authenticator || specialScopes.length > 0 ) {
//     Authenticator = new AzureAuthenticator({
//       azureClientId: AzureAdClient.info.clientId, 
//       azureTenantId: AzureAdClient.info.tenantId, 
//       scopes: [...OIDC_DEFAULT_SCOPES, ...AzureAdClient.scopes, ...specialScopes],
//       domainHint: AzureAdClient.info.dommainHint
//     })
//   }
//   return Authenticator
// }

let Authenticator = undefined;

export const getAuthenticator = (specialScopes = []) => {
  if (!Authenticator || specialScopes.length > 0) {
    const context = createAuthContext();
    context.scopes = [...OIDC_DEFAULT_SCOPES, ...AzureAdClient.scopes, ...specialScopes];

    context.azureClientId = AzureAdClient.info.clientId;
    context.azureTenantId = AzureAdClient.info.tenantId;

    Authenticator = createAzureAuthenticator(context);
  }

  return Authenticator;
};

export const loginWithHint = async (hint) => {
  const auth = getAuthenticator()
    try {
      token = await auth.authenticate(hint)
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        console.error(`InteractionRequiredAuthError caught and clearing session for retry`)
        sessionStorage.clear()
        token = await getToken(false)
      } else throw (e)
    }
}

export const loginWithSSO = async () => {
  const auth = getAuthenticator()
    try {
      token = await auth.acquireTokenRedirect()
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        console.error(`InteractionRequiredAuthError caught and clearing session for retry`)
        sessionStorage.clear()
        token = await getToken(false)
      } else throw (e)
    }
}

let token = undefined
export const getTokenExpirationMs = (tokenValue) => {
  if (!tokenValue) return 0

  if (tokenValue.idTokenClaims?.exp) {
    return new Date(tokenValue.idTokenClaims.exp * 1000).getTime()
  }

  if (tokenValue.expiresOn instanceof Date) {
    return tokenValue.expiresOn.getTime()
  }

  if (typeof tokenValue.expiresOn === 'number') {
    return tokenValue.expiresOn
  }

  return 0
}

export const getToken = async (_cacheOnly = false, specialScopes = []) => {
  if (_cacheOnly) return token
  
  if (token) {
    // Refresh slightly before the token expires to avoid backend 401s.
    const expirationTime = getTokenExpirationMs(token)
    const currentTime = new Date().getTime()
    if ((expirationTime - currentTime) / 1000 / 60 < 30) {
      token = undefined
    }
  }
  if (!token) {
    const auth = getAuthenticator(specialScopes)
    try {
      token = await auth.authenticate()
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        console.error(`InteractionRequiredAuthError caught and clearing session for retry`)
        sessionStorage.clear()
        token = await getToken(_cacheOnly, specialScopes)
      } else throw (e)
    }
  }
  EventBus.emit('token', token)
  return token
}
export const clearMinorToken = () => {
  token = undefined
}

export const getRequestConfig = async () => {
  const token = await getToken()
  return {
    headers: {        
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token.idToken}`,
    }
  }
}

export function getHostUrl() {
  return `${[window.location.protocol,'//',
  window.location.hostname,
  window.location.hostname === 'localhost' ? [':',window.location.port].join('') : ''].join('')}`
}

export function logout() {
  getAuthenticator().logout()
}
